
import './App.css';
import { router } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React, { useEffect } from 'react';
import baseURL from './Components/url';
import { aplicarConfiguracionEnDOM } from './Components/useSiteConfig';

function App() {
  useEffect(() => {
    const aplicarMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Cargar y aplicar configuración global de favicon, colores y SEO
    fetch(`${baseURL}/configuracionGet.php`)
      .then(res => res.json())
      .then(data => {
        const config = data?.config;
        if (config) {
          aplicarConfiguracionEnDOM(config);

          // Si estamos en el panel de administración, no sobrescribir metadatos SEO
          if (typeof window !== 'undefined' && window.location.pathname.startsWith('/dashboard')) {
            return;
          }

          if (config.meta_title) document.title = config.meta_title;
          aplicarMeta('description', config.meta_description);
          aplicarMeta('keywords', config.meta_keywords);
          aplicarMeta('author', config.meta_author);
          aplicarMeta('robots', config.robots_index);

          // Google Search Console
          if (config.google_verification) {
            aplicarMeta('google-site-verification', config.google_verification);
          }

          // Open Graph
          aplicarMeta('og:title', config.og_title || config.meta_title, true);
          aplicarMeta('og:description', config.og_description || config.meta_description, true);
          aplicarMeta('og:image', config.og_image, true);
          aplicarMeta('og:type', config.og_type || 'website', true);
          aplicarMeta('og:site_name', config.site_name, true);

          // Twitter
          aplicarMeta('twitter:card', config.twitter_card || 'summary_large_image');
          aplicarMeta('twitter:title', config.og_title || config.meta_title);
          aplicarMeta('twitter:description', config.og_description || config.meta_description);
          aplicarMeta('twitter:image', config.og_image);

          // Google Analytics 4
          if (config.google_analytics_id && !document.getElementById('ga4-script')) {
            const script = document.createElement('script');
            script.id = 'ga4-script';
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${config.google_analytics_id}`;
            document.head.appendChild(script);

            const inlineScript = document.createElement('script');
            inlineScript.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${config.google_analytics_id}');
            `;
            document.head.appendChild(inlineScript);
          }
        }
      })
      .catch(() => {});
  }, []);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
